import { render, staticRenderFns } from "./wenXueChangShi.vue?vue&type=template&id=a5e6fefe&scoped=true&"
import script from "./wenXueChangShi.vue?vue&type=script&lang=js&"
export * from "./wenXueChangShi.vue?vue&type=script&lang=js&"
import style0 from "./wenXueChangShi.vue?vue&type=style&index=0&id=a5e6fefe&prod&lang=scss&"
import style1 from "./wenXueChangShi.vue?vue&type=style&index=1&id=a5e6fefe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e6fefe",
  null
  
)

export default component.exports